import { render, staticRenderFns } from "./AmcList.vue?vue&type=template&id=ff9da44c&scoped=true"
import script from "./AmcList.vue?vue&type=script&lang=js"
export * from "./AmcList.vue?vue&type=script&lang=js"
import style0 from "./AmcList.vue?vue&type=style&index=0&id=ff9da44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9da44c",
  null
  
)

export default component.exports